const getFirst = (data,type) => {
    const [ first = null,...rest ] = data?.[type];
    
    return first;
}

export default getFirst;